"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadWrapper = void 0;
var react_1 = __importStar(require("react"));
var ProgressBar_1 = require("../LoadersAndProgress/ProgressBar");
var styled_1 = require("./styled");
var FileUploadShell_1 = require("./comps/FileUploadShell");
var FileUploadWrapper = function (_a) {
    var smallPlaceholderUI = _a.smallPlaceholderUI, isLoading = _a.isLoading, multiple = _a.multiple, containerShape = _a.containerShape, uploadProgress = _a.uploadProgress, mediaType = _a.mediaType, handleUpload = _a.handleUpload, onChange = _a.onChange, value = _a.value, id = _a.id, children = _a.children, width = _a.width, height = _a.height, _b = _a.enableClickUpload, enableClickUpload = _b === void 0 ? true : _b, // For components which has different options apart from upload, like VideoInput component allowing upload on wrapper click should be disabled
    enableFilesDrop = _a.enableFilesDrop, styledPlaceholderWrapperRef = _a.styledPlaceholderWrapperRef;
    var _c = (0, react_1.useState)(false), dragOverActive = _c[0], setDragOverActive = _c[1];
    return (react_1.default.createElement(styled_1.StyledPlaceholderWrapper, { smallPlaceholderUI: smallPlaceholderUI, ref: styledPlaceholderWrapperRef, dragOverActive: dragOverActive, width: width, height: height }, isLoading ? (react_1.default.createElement(ProgressBar_1.ProgressBar, { progress: uploadProgress, text: uploadProgress && uploadProgress !== 100
            ? uploadProgress + "%"
            : "Almost Done..." })) : (react_1.default.createElement(FileUploadShell_1.FileUploadShell, { isLoading: isLoading, enableFilesDrop: enableFilesDrop, multiple: multiple, setDragOverActive: setDragOverActive, handleUpload: handleUpload, onChange: onChange, value: value, id: id, mediaType: mediaType, enableClickUpload: enableClickUpload },
        react_1.default.createElement(styled_1.StyledPlaceholder, { containerShape: containerShape, smallPlaceholderUI: smallPlaceholderUI, enableClickUpload: enableClickUpload }, children)))));
};
exports.FileUploadWrapper = FileUploadWrapper;
